module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074da_banner_800x600.653c9004.png";